"use strict";

class SuperUserValidationTokensController {

    constructor($http, $scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSConfirmationService) {
        const self = this;

        self.$http = $http;
        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.searchParams = {};
        self.validationTokens = [];
    }

    getValidationTokens() {
        const self = this;

        self.validationTokens = [];

        if (!self.searchParams.code) {
            return;
        }

        let url = 'sec/token/' + self.searchParams.code;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.validationTokens = response.data.validation_tokens;
        });
    }
}

SuperUserValidationTokensController.$inject = ['$http', '$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSConfirmationService'];
app.controller('SuperUserValidationTokensController', SuperUserValidationTokensController);

